export const tileSizeVars = {
  '--tile-size': 'clamp(80px, 10vw, 110px)',
  '--tile-gap': 'clamp(10px, 2vw, 16px)',
  width: 'calc(var(--tile-size) * 4 + var(--tile-gap) * 3)',
  height: 'calc(var(--tile-size) * 4 + var(--tile-gap) * 3)',
};

export const opponentTileSizeVars = {
  '--tile-size': 'clamp(64px, 8vw, 90px)',
  '--tile-gap': 'clamp(8px, 1.6vw, 12px)',
  width: 'calc(var(--tile-size) * 4 + var(--tile-gap) * 3)',
  height: 'calc(var(--tile-size) * 4 + var(--tile-gap) * 3)',
};
